import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6';
import Cookies from 'js-cookie';
import GLightbox from 'glightbox';
import { $Elements, BrowserEvents, Classes, Elements } from './constants';
import { calculateMenuOffset, replaceHoverByActive } from './helpers';

//=================================
//	!---------- GLOBAL ----------
//=================================

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- jQuery Related ----------

;(function($) {

	$Elements.document.ready(() => $Elements.document.trigger(BrowserEvents.page.enter));

	$Elements.document.on(BrowserEvents.page.enter, function() {

		replaceHoverByActive();

		// ---------- Menu ----------

		$('.menu-toggle').click(function(e) {
			e.preventDefault();

			if($Elements.body.hasClass(Classes.menuOpen)) {
				$Elements.body.removeClass(Classes.menuOpen);
				enableBodyScroll(Elements.MenuWrapper);
			}
			else {
				$Elements.body.addClass(Classes.menuOpen);
				disableBodyScroll(Elements.MenuWrapper);
			}
		});

		$('.menu-overlay').click(function(e) {
			e.preventDefault();

			$('.menu-toggle').trigger('click');
		});

		$('.navbar-menu a, .menu-wrapper a').click(function(e) {

			const linkTarget = this.getAttribute('href');
			const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

			if(sectionTarget.substring(0, 1) === '#') {

				e.preventDefault();

				const section = $(sectionTarget);

				if(section.length) {

					window.history.replaceState(null, null, sectionTarget);

					$Elements.body.removeClass(Classes.menuOpen);
					enableBodyScroll(Elements.MenuWrapper);

					$('html, body').stop().animate({
						scrollTop: calculateMenuOffset(section)
					}, 1000);
				}
				else {
					window.location = linkTarget;
				}
			}
		});

		$Elements.window.on('load', function() {

			const linkTarget = window.location.href;
			const sectionTarget = linkTarget.substring(linkTarget.lastIndexOf('#'), linkTarget.length);

			if(sectionTarget.substring(0, 1) === '#') {

				const section = $(sectionTarget);

				if(section.length) {
					$Elements.body.removeClass(Classes.menuOpen);
					enableBodyScroll(Elements.MenuWrapper);
					$('html, body').scrollTop(calculateMenuOffset(section));
				}
			}
		});

		// ---------- Animsition ----------

		//$Elements.MainWrapper.animsition({
		//	inClass: 'fade-in',
		//	outClass: 'fade-out',
		//	inDuration: 600,
		//	outDuration: 400,
		//	linkElement: 'a:not([target="_blank"]):not([href*="#"]):not([href^="mailto:"]):not([href^="tel:"]):not(.void-link):not([data-lity]):not([href=""])',
		//	loading: false,
		//});
		//
		//$Elements.MainWrapper.on('animsition.outStart', () => Elements.LoadingBar.classList.add(Classes.loading));
		//$Elements.MainWrapper.on('animsition.inEnd', () => Elements.LoadingBar.classList.remove(Classes.loading));

		// ---------- Links ----------

		$('a[href="#"], .void-link').click(function(e) {
			e.preventDefault();
		});

		$('[data-scroll-to]').click(function(e) {
			e.preventDefault();

			const self = $(this);
			const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

			if(target.length) {

				$('html, body').stop().animate({
					scrollTop: calculateMenuOffset(target)
				}, 1000);
			}
		});

		$('.select-dropdown .dropdown-menu .btn').click(function() {
			$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
		});

		$('[target="lightbox"]').each(function(index) {

			this.classList.add('lightbox-' + index);

			GLightbox({
				selector: 'lightbox-' + index,
				openEffect: 'fadeIn',
				closeEffect: 'fadeOut',
				videosWidth: 1280,
			});
		});

		$('[target^="lightbox-gallery"]').each(function() {

			const gallery = this.getAttribute('target');
			this.classList.add(gallery);

			GLightbox({
				selector: gallery,
				openEffect: 'fadeIn',
				closeEffect: 'fadeOut',
				videosWidth: 1280,
			});
		});

		// ---------- Inline SVGs ----------

		$('img.svg').inlineSvg();

		// ---------- LazyLoad ----------

		$Elements.window.on(BrowserEvents.lazyload, function() {

			lazySizes.loader.checkElems();
			lazySizes.autoSizer.checkElems();

		});

		$Elements.window.trigger(BrowserEvents.lazyload);

		// ---------- Disclaimer ----------

		$('.close-disclaimer').click(function(e) {
			e.preventDefault();

			Cookies.set('tc-disclaimer', true, {
				expires: 365,
				path: '/',
			});

			$('#disclaimer').fadeOut(1000, function() {
				$(this).remove();
			});

			$Elements.body.removeClass('disclaimer-open');
		});

		$('#cookies-law').on('closed.bs.alert', function() {

			Cookies.set('tc-cookies', true, {
				expires: 365,
				path: '/',
			});

			$('.cookies-law').remove();
		});

	});

}(jQuery));
